// Copy for the home page lives in src/i18n/locales/*.json. This file keeps only what is not
// translatable — asset paths and contact data — so a phone number is edited in one place
// instead of three. See Contacts.js / Partners.js for how these pair up with translation keys.

export const partnerLogos = [
    "/logos/tera.png",
    "/logos/bucuria.png",
    "/logos/franzeluta.png",
    "/logos/nestle.png",
    "/logos/unilever.png",
    "/logos/coca-cola.png"
]

export const contacts = {
    cards: [
        {
            phone: "+373 22 317 901",
            email: "info@ramaiana.md",
        },
        {
            phone: "+373 22 312 161",
            email: "depozit2@ramaiana.md",
        },
        {
            phone: "+373 22 317 514",
            email: "depozit3@ramaiana.md",
        },
        {
            phone: "+373 22 410 855",
            email: "depozit4@ramaiana.md",
        },
        {
            phone: "+373 60 365 710",
            email: "info@ramaiana.md",
        }
    ]
}
